import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchMultipleObservation } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const ObservationDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
  rowData,
  mappedData,
  required,
}) => {
  const observationName = getValues()?.observation;
  const selectedObservation = watch("observation_id");

  const {
    data: Observations,
    isLoading,
    error,
  } = useQuery(
    ["ObservationDropdown"],
    fetchMultipleObservation,
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  const optionsList = useMemo(
    () =>
      Observations?.data?.data?.map((observation) => ({
        value: observation?.id,
        label: observation?.observation,
      })) || [],
    [Observations]
  );

  const options = mappedData
    ? optionsList?.filter((ele) => !mappedData.includes(ele.label))
    : optionsList;

  useEffect(() => {
    if (rowData && options.length) {
      const selectedOption = options.find(
        (option) => option.value === rowData?.observation_id
      );
      setValue("observation_id", selectedOption?.value);
      setValue("observation", selectedOption?.label);
    }
  }, [rowData, options, setValue]);

  const selectedOption =
    options.find(
      (option) => String(option.value) === String(selectedObservation)
    ) ||
    options.find((option) => option.label === observationName) ||
    null;

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading observations</div>;

  return (
    <>
      <Controller
        name="observation_id"
        control={control}
        rules={{
          required: required ? "Observation is required" : false,
          validate: (value) => {
            if (required && !value) return "Observation is required";
            return true;
          },
        }}
        render={({ field }) => (
          <Select
            {...field}
            options={options}
            isClearable
            placeholder="Select Observation Name"
            value={selectedOption || null}
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              control: (base) => ({
                ...base,
                height: "42px",
              }),
              option: (base, { isFocused, isSelected }) => ({
                ...base,
              }),
            }}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "";
              field.onChange(value);
              setValue("observation_id", value);
              setValue("observation", selectedOption?.label || "");
            }}
            className={`react-select-container ${
              errors.observation_id ? "is-invalid" : ""
            }`}
          />
        )}
      />
      {errors.observation_id && (
        <div className="invalid-feedback">{errors.observation_id.message}</div>
      )}
    </>
  );
};

export default ObservationDropdown;
